<template>
  <div class="absolute right-0 p-3 z-0 flex items-center">
    <a
      :href="redirectToEdit"
      target="_blank"
      v-if="['admin', 'super'].includes(role)"
      class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-sm leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-xs sm:leading-4"
    >
      Editar
    </a>
  </div>
</template>

<script>
import { computed } from "vue";
import { useStore } from "vuex";

export default {
  props: { data: Object, isCollection: Boolean },
  setup(props) {
    const store = useStore();

    const role = computed(() => store.state.role);
    const redirectToEdit = computed(
      () =>
        `${process.env.VUE_APP_ADBOX_ADMIN_FRONT_URL}/advertisements/edit/${props.data.id}`
    );

    return { role, redirectToEdit };
  },
};
</script>

<style></style>
